export default __webpack_public_path__ + "static/media/not-found.1d91afd4.svg";